<syslink-chart
    [title]="'CreditLimitHistory' | translate"
    [showLegend]="false"
    [data]="data"
    [series]="series"
></syslink-chart>